import { createGlobalStyle } from 'styled-components';
import { colors, shadow } from './theme';

export default createGlobalStyle`
*,
  html,
  body {
    padding: 0;
    margin: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    -webkit-text-size-adjust: none;
  }

  body {
    font-size: 14px;
    line-height: 1.375em;
    font-weight: normal;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0 auto;
    -webkit-text-size-adjust: auto;
    -moz-text-size-adjust: auto;
    -ms-text-size-adjust: auto;
    text-size-adjust: auto;
    font-family: 'Inter', sans-serif;
    overflow-x: hidden;
    background-color: ${colors.lightgrey};
    color: ${colors.text};
  }

  .overflow {
    overflow: hidden;
    height: 100vh;
  }

  p {
    font-size: 14px;
    line-height: 28px;
    margin: 0;
    margin-bottom: 20px;
    color: ${colors.black};
    font-weight: normal;
    font-family: 'Inter', sans-serif;
    color: ${colors.text};

    @media (max-width: 767px) {
      font-size: 12px;
      line-height: 22px;
    }
  }
  button {
    transition: 0.3s ease;
  }
  input,
  select,
  option,
  button {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
  }

  h1,
  h2,
  h3,
  h4,
  .h1,
  .h2,
  .h3,
  .h3 {
    font-weight: bold;
    margin: 0;
    margin-bottom: 25px;
    color: ${colors.text};
  }

  h1,
  .h1 {
    margin: 0;
    margin-bottom: 15px;
    font-size: 46px;
    line-height: 1.026;

    @media (max-width: 767px) {
      font-size: 50px;
    }
  }

  h2,
  .h2 {
    font-size: 50px;
    line-height: 1.2;

    @media (max-width: 979px) {
      font-size: 40px;
    }

    @media (max-width: 767px) {
      font-size: 30px;
    }
  }

  h3,
  .h3 {
    font-size: 38px;
    line-height: 1.2;

    @media (max-width: 979px) {
      font-size: 30px;
      line-height: 1.333;
    }

    @media (max-width: 767px) {
      font-size: 24px;
    }
  }

  h4,
  .h4 {
    font-size: 20px;
    line-height: 1.22;
    font-weight: 400;
    color: ${colors.black};

    @media (max-width: 979px) {
      font-size: 18px;
    }
  }

  h5,
  .h5 {
    font-size: 18px;
    line-height: 1.22;
    font-weight: 400;
    color: ${colors.black};

    margin-bottom: 20px;

    @media (max-width: 979px) {
      font-size: 16px;
    }
  }

  a {
    color: ${colors.black};
    cursor: pointer;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    text-decoration: none;
  }

  img,
  video {
    max-width: 100%;
    vertical-align: middle;
  }

  a {
    img {
      pointer-events: all;
    }
  }
  a,
  a:hover,
  a:focus {
    outline: none;
  }
  ul,
  ol {
    padding-left: 22px;
    font-size: 14px;
    line-height: 1.222;
  }

  li {
    margin-bottom: 0.75em;
    line-height: 22px;
  }

  hr {
    margin: 25px 0;
    opacity: 0.1;
    border-color: #000;
  }

  label {
    display: block;
    margin-top: 20px;
    font-size: 14px;
    line-height: 35px;
  }

  input[type='email'],
  input[type='text'],
  .form-control,
  textarea {
    display: block;
    width: 100%;
    border-radius: 8px;
    padding: 18px 20px;
    box-shadow: none;
    font-size: 16px;
    outline: none;
    border: 1px solid #b5b5b5;
    background-color: transparent;
    transition: 0.3s ease-out;

    &:focus {
        border:1px solid ${colors.blue} ;
      }
  }
  textarea.form-control {
    resize: vertical;
    height: 93px;
  }
  input[type='email']:hover,
  input[type='text']:hover,
  textarea:hover,
  input[type='email']:focus,
  input[type='text']:focus,
  textarea:focus {
    outline: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 transparent !important;
    box-shadow: 0 0 0 transparent !important;
  }

  button {
    cursor: pointer;
  }

  select.form-control {
    -webkit-appearance: none;
    appearance: none;
    background-image: url(/img/chevron-down.svg);
    background-size: 10px;
    background-repeat: no-repeat;
    background-position: 98% center;
  }

  .container {
    max-width: 1220px;
    padding: 0 15px;
    margin: 0 auto;

    @media (max-width: 1200px) {
      max-width: 960px;
    }
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .font-16 {
    font-size: 16px;
    line-height: 28px;
  }

  .flex {
    display: flex ;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;

    @media (max-width: 767px) {
      margin: 0;
    }
  }
  .nowrap {
    flex-wrap: nowrap;
  }

  .align-items-center {
    align-items: center;
  }
  .justify-space-between {
    justify-content: space-between;
  }
  .justify-flex-end {
    justify-content: flex-end;
  }
  .justify-content-center {
    justify-content: center;
  }
  .row-reverse {
    flex-direction: row-reverse;
  }
  .flex-1 {
    flex: 1;
  }
  .col-3 {
    width: 25%;
  }

  .col-4 {
    width: 33.333%;
  }

  .col-5 {
    width: 41.6%;
  }

  .col-6 {
    width: 50%;
  }

  .col-8 {
    width: 66.4%;
  }
  .col-9 {
    width: 75%;
  }
  .col-7 {
    width: 58%;
  }
  .col-2 {
    width: 16.6%;
  }
  .col-10 {
    width: 83.3%;
  }
  .col-12 {
    width: 100%;
  }
  .col {
    padding: 0 15px;

    @media (max-width: 767px) {
      width: 100%;
      padding: 0;
    }
  }

  @media (min-width: 1024px) {
    .offset-1 {
      margin-left: 8.333333%;
    }

    .offset-2 {
      margin-left: 16.666667%;
    }

    .offset-3 {
      margin-left: 25%;
    }

    .offset-4 {
      margin-left: 33.333333%;
    }

    .offset-5 {
      margin-left: 41.666667%;
    }

    .offset-6 {
      margin-left: 50%;
    }

    .offset-7 {
      margin-left: 58.333333%;
    }

    .offset-8 {
      margin-left: 66.666667%;
    }

    .offset-9 {
      margin-left: 75%;
    }

    .offset-10 {
      margin-left: 83.333333%;
    }

    .offset-11 {
      margin-left: 91.666667%;
    }
  }
  .blue-link {
    color: ${colors.blue};
    line-height: 28px;
    display: inline-block;

    &:hover {
      color: ${colors.black};
    }
  }
  .weight-500 {
    font-weight: 500;
  }
  .weight-600 {
    font-weight: 600;
  }
  .button {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    background: ${colors.blue};
    padding: 14px 25px;
    display: inline-block;
    text-align: center;
    transition: 0.4s all;
    border: none;
    border-radius: 8px;

    &:hover {
      color: #fff;
      background-color: ${colors.bluehover};
    }

    svg {
      width: 15px;
      vertical-align: middle;
      margin-left: 10px;

      path {
        transition: 0.3s all;
        stroke: #fff;
      }
    }

    &.light-blue-button {
      background-color: ${colors.lightBlue};
      color: ${colors.blue};

      &:hover {
        background-color: ${colors.blue};
        color: #fff;
      }
    }
    &.light-red-button {
      background-color: ${colors.lightRed};
      color: ${colors.red};

      &:hover {
        background-color: ${colors.red};
        color: #fff;
      }
    }

    &.grey-button {
      background-color: #f7f7f7;
      color: ${colors.black};

      &:hover {
        background-color: #ddd;
        color: ${colors.black};
      }
    }

    &.border-button {
      background-color: transparent;
      border: 1px solid #D9DFE8;
      color: ${colors.black};

      &:hover {
        border:1px solid ${colors.blue} ;
      }
    }

    &.button-unstyled {
      background-color: transparent;
      background-color: transparent;
      border: 0;
      box-shadow: none;
      text-decoration: none;
      padding: 0;
      margin: 0;
      color: ${colors.blue};

      &:focus {
        outline: 0;
      }
    }
  }

  .full-width {
    width: 100%;
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .heading {
    color: ${colors.text};
    font-size: 28px;
    font-weight: bold;
    line-height: 38px;

    &.inner-heading {
      font-size: 42px;
      line-height: 52px;
    }

    @media (max-width: 767px) {
      font-size: 24px;
      line-height: 35px;

      &.inner-heading {
        font-size: 28px;
        line-height: 38px;
      }
    }
  }

  .link-unstyled {
    color: ${colors.blue};
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
  }
  .hidden {
    display: none !important;
  }
  .visible-mobile,
  .visible-tablet {
    display: none !important;
  }
  @media (max-width: 767px) {
    .hidden-mobile {
      display: none !important;
    }
    .visible-mobile {
      display: block !important;
    }
  }

  @media (max-width: 990px) {
    .visible-tablet {
      display: block !important;
    }
  }

  .no-margin {
    margin: 0 !important;
  }
  .padding-30 {
    padding: 30px;
  }

  .position-relative {
    position: relative;
  }

  .button-arrow {
    font-weight: 600;
    font-size: 18px;
    line-height: 133%;
    letter-spacing: 0.115em;
    color: ${colors.blue};
    transition: transform ease 0.3s;
    transform: translateX(0);
    display: inline-block;

    svg {
      display: inline-block;
      vertical-align: middle;
      transition: transform ease 0.3s;
      transform: translateX(0);
      transition-delay: 0.1s;
    }

    &:hover {
      transform: translateX(20px);

      svg {
        transform: translateX(5px);
      }
    }
  }

  .button-chevron-left {
    position: relative;
    color: rgba(0, 0, 0, 0.6);

    img {
      margin-right: 6px;
      transform: translateX(0);
      transition: 0.4s ease;
    }

    &:hover {
      img {
        transform: translateX(-10px);
      }
    }
  }
  .db-area-main {
    margin-left: auto;
    width: calc(100% - 75px);
    padding: 115px 30px;
    
    .db-container {
      max-width: 1250px;
      margin: 0 auto;
    }

    .db-heading {
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      margin: 0 0 35px;
    }
  }

  .single-color-circle {
    width: 37px;
    height: 37px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.06);
    display: inline-block;
    border-radius: 50%;
    margin-right: 15px;

    &.add-color {
      border: 1px solid #d8d8d8;
      background-color: transparent;
      box-shadow: none;

      &:hover {
        border: 1px solid ${colors.blue};
        background-color: ${colors.blue};

        svg path {
          fill: #fff;
        }
      }
    }
  }

  .single-db-block {
    margin-bottom: 80px;
  }

  .table {
    width: 100%;
    text-align: left;
  }
  .table th,
  .table td {
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
    padding: 10px;
  }
  .table.typography-table {
    border-spacing: 0 15px;
    margin-bottom: 35px;
    th {
      padding: 10px 25px;
    }
    td {
      padding: 25px;
      border: none;
      background: #fafafa;

      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
    .custom-select {
      max-width: 150px;
      min-width: 0;
    }
    .font-weight-select {
      max-width: 120px;
    }
    .font-size-select {
      max-width: 100px;
    }
  }

  .custom-select {
    min-width: 150px;
    .css-yk16xz-control {
      background: #ffffff;
      border: 1px solid #e9e9e9;
      box-sizing: border-box;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 400;

      .css-1okebmr-indicatorSeparator {
        display: none;
      }
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 28px;
    margin: 0;

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: '';
        height: 20px;
        width: 20px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
        border-radius: 34px;
      }
    }

    &.switch-green {
      input:checked + .slider {
        background-color: ${colors.green};
      }
    }

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    input:checked + .slider {
      background-color: ${colors.blue};
    }

    input:focus + .slider {
      box-shadow: ${shadow.shadow};
    }

    input:checked + .slider:before {
      transform: translateX(22px);
    }
  }

  .form-group {
    margin-bottom: 38px;

    label {
      font-weight: 600;
      font-size: 16px;
      line-height: 26px;
      margin: 0 0 11px;
    }
  }

  .alert {
    padding: 15px 15px 15px 50px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 6px;

    &.alert-warning {
      background: url(/img/warning-icon.svg) ${colors.lightYellow};

      background-repeat: no-repeat;
      background-position: 16px 18px;
      border: 1px solid ${colors.lightYellow};
    }
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .db-back-link {
    margin-bottom: 40px;
    display: inline-block;
  }

  .db-tab-content-block {
    .sidebar-col {
      width: 240px;
    }

    .right-block-col {
      width: calc(100% - 240px);
    }
  }

  .create-wrokspace {
    h1 {
      font-size: 32px;
      line-height: 40px;
      margin: 0 0 10px;
    }

    p {
      font-size: 16px;
      margin: 0;
    }
  }

  .workspace-filters {
    justify-content: flex-end;

    .tile-filter {
      margin-left: 25px;
      background-color: transparent;
      border: none;
    }
  }

  .single-wrokspace-tile {
    padding: 0 15px;
    width: 20%;
    text-align: center;
    margin-bottom: 30px;
    background-color: transparent;
    border: none;

    .padding-30 {
      transition: 0.4s ease;
      transform: translateY(0) scale(1);
      &:hover {
        transform: translateY(-10px) scale(1.04);
        box-shadow: 0 10px 45px rgba(0, 0, 0, 0.025);
      }
    }

    .workspace-logo {
      max-width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 auto 20px;
      line-height: 80px;
      font-size: 27px;

      img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    .worksapce-desc {
      h4 {
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 15px;
      }
      .workspace-people {
        display: flex;
        justify-content: center;
        margin-left: 10px;

        .single-person {
          position: relative;
          margin-left: -10px;

          .person-name {
            position: absolute;
            background-color: ${colors.blue};
            color: #fff;
            padding: 4px;
            left: -50%;
            right: 0;
            min-width: 120px;
            border-radius: 6px;
            box-shadow: 0px 4px 4px rgba(221, 221, 221, 0.25);
            opacity: 0;
            visibility: hidden;
            transition: 0.3s ease;
          }

          &:hover {
            .person-name {
              opacity: 1;
              visibility: visible;
            }
          }

          .perosn-photo {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
            border: 1px solid #fff;
            display: block;

            img {
              object-fit: cover;
              object-position: center;
              display: block;
              height: 100%;
              width: 100%;
            }
          }
        }
        .total-persons {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          line-height: 30px;
          box-shadow: 2.39493px 1.59662px 31.9324px rgba(0, 0, 0, 0.12);
          margin-left: -10px;
          position: relative;
          z-index: 1;
          display: block;
          background-color: #fff;
        }
      }
    }
  }
  .red {
    color: ${colors.red};
  }
  .light-blue-bg {
    background-color: ${colors.lightBlue};
  }
  .light-red-bg {
    background-color: ${colors.lightRed};
  }
  .light-yellow-bg {
    background-color: ${colors.lightYellow};
  }
  .light-green-bg {
    background-color: ${colors.lightGreen};
  }
  .no-padding {
    padding: 0 !important;
  }
  .round-icon {
    width: 104px;
    height: 104px;
    display: inline-block;
    line-height: 104px;
    border-radius: 50%;
  }
  .round-icon-small {
    width: 45px;
    height: 45px;
    line-height: 42px;
    display: inline-block;
    border-radius: 50%;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .small-box-heading {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }

  .darkgrey {
    color: ${colors.darkgrey};
  }

  .small-box-heading {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
  .pad-15 {
    padding: 15px;
  }
  .grey-bg {
    background-color: ${colors.lightgrey};
  }
  .green {
    color: ${colors.green};
  }
  .plan-due-block {
    margin-bottom: 30px;
    p {
      margin: 0 0 8px;
    }

    h4 {
      margin: 0;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .user-numbers-block {
    margin-bottom: 30px;
    p {
      font-size: 32px;
      line-height: 48px;
    }
  }
  .small-heading {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
  }

  .payment-method-block {
    margin-bottom: 15px;
  }

  .card-info {
    display: flex;
    align-items: center;

    > span {
      width: 50px;
      height: 36px;
      border: 1px solid #f7f7f7;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
    }
    p {
      margin: 0 0 0 15px;
      font-size: 16px;
      font-weight: 600;
      line-height: 26px;
    }
  }
  .dot {
    width: 6px;
    height: 6px;
    background-color: #101218;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
  }
  .bottom-side-link {
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
  .currency-select {
    max-width: 150px;
    margin-left: auto;
  }

  .pay-tabs {
    width: 300px;
    padding: 8px;
    background-color: #f2f2f2;
    border-radius: 8px;
    display: flex;

    button {
      padding: 15px 10px;
      border: none;
      background-color: transparent;
      width: 50%;
      text-align: center;
      transition: 0.4s ease;
      font-size: 16px;
      font-weight: 600;
      opacity: 0.4;

      &.active {
        opacity: 1;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }

  .workspace-price-block {
    width: 50%;

    h3 {
      font-size: 24px;
      font-weight: 400;
      color: #0e64ff;
    }

    .price {
      font-size: 32px;
      line-height: 40px;
      font-weight: 800;
      margin-bottom: 0;

      span {
        font-size: 27px;
        opacity: 0.4;
      }
    }
  }
  .check-list {
    list-style-type: none;
    padding-left: 0;

    li {
      margin-bottom: 16px;
      background-image: url(/img/green-check.svg);
      background-repeat: no-repeat;
      background-position: 0 4px;
      padding-left: 25px;
    }
  }
  .arrow-list {
    list-style-type: none;
    padding-left: 0;

    li {
      margin-bottom: 16px;
      background-image: url(/img/chevron-right-blue.svg);
      background-repeat: no-repeat;
      background-position: 0 6px;
      padding-left: 20px;
    }
  }

  .search-input {
    display: flex;

    input {
      border: none;
      height: 50px;
      padding: 10px;
    }
  }

  .inovice-table {
    th {
      background-color: #f7f7f7;
      border: none;
      padding: 18px;
      font-size: 14px;
    }

    td {
      font-weight: 400;
      padding: 18px;
      font-size: 14px;

      a {
        margin-left: 8px;
      }
    }
    tr {
      td:first-child,
      th:first-child {
        padding-left: 50px;
      }
    }

    tbody tr:nth-child(2n) {
      background-color: #fbfbfb;
    }
  }
  .workspace-select-header {
    min-width: 200px;
    margin-left: 20px;
    margin-bottom: 30px;
  }

  .member-admin {
    padding: 18px 20px;
    background-color: #f9fbff;
    border-radius: 8px;
    margin: 0 0 20px;
  }
  .round-image {
    border-radius: 50%;
    overflow: hidden;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    font-weight: 500;
    background-color: ${colors.lightBlue};
    color: ${colors.blue};
  }
  .round-image img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .width-100 {
    width: 100px;
  }
  .min-width-100 {
    min-width: 100px;
  }

  .member-list-main {
    max-height: 375px;

    .single-member-line {
      margin: 0 0 30px;
      flex-wrap: nowrap;

      .col {
        padding: 0 10px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .dropdown-menu {
        transform: none;
        left: -80px;

        &:before {
          left: auto;
          right: 20px;
        }
      }
    }
  }

  .overflow-auto {
    overflow: auto;
  }

  .member-invite-main {
    display: flex;
    align-items: baseline;

    .member-invite-input {
      flex: 1;
      display: flex;
      margin-right: 20px;
      align-items: center;
      border: 1px solid #ddd;
      padding: 10px 15px;
      border-radius: 8px;

      input {
        border: none;
        padding: 0;
      }

      .member-access-select {
        width: 120px;

        .css-yk16xz-control {
          border: none;
        }
        .css-1okebmr-indicatorSeparator {
          display: none;
        }
      }
    }
  }
  .subhead {
    font-size: 16px;
    line-height: 26px;
    letter-spacing: -0.5px;
    color: #b5b5b5;
  }

  .workspace-features-block {
    p {
      font-size: 16px;
      margin: 0;
    }

    img {
      margin-right: 10px;
    }
    .flex-row {
      padding-bottom: 15px;
    }
  }
  .button-block {
    display: block;
  }

  .setup-step-count {
    display: flex;
    justify-content: stretch;
    padding: 35px 30px 0px;

    .single-count {
      text-align: center;
      flex: 1;
      position: relative;

      &.active {
        span {
          background-color: ${colors.blue};
          color: #fff;
          border: 1px solid ${colors.blue};
        }

        p {
          color: ${colors.blue};
        }
      }
      &.completed {
        span {
          background-color: ${colors.green};
          font-size: 0;
          border: 1px solid ${colors.green};

          &:before {
            position: absolute;
            width: 18px;
            height: 18px;
            background-image: url(/img/white-check.svg);
            background-repeat: no-repeat;
            background-size: contain;
            content: '';
            left: 0;
            right: 0;
            margin: 0 auto;
            top: 12px;
          }
        }
      }

      &:after {
        position: absolute;
        left: 106px;
        width: 50%;
        height: 1px;
        background-color: #dbdbdb;
        content: '';
        top: 18px;
      }

      &:last-child:after {
        display: none;
      }

      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 37px;
        border: 1px solid #b5b5b5;
        border-radius: 50%;
        color: #b5b5b5;
        margin-bottom: 15px;
        transition: 0.4s ease;
        position: relative;
      }

      p {
        margin: 0;
        font-weight: 500;
        transition: 0.4s ease;
      }
    }
  }
  .create-team-steps {
    padding: 40px 0 20px;
    display: flex;
    overflow: hidden;
  }

  .steps-member-list {
    max-height: 275px;
    margin-bottom: 30px;

    .single-member-line {
      margin: 30px -15px !important;
    }
    .custom-select {
      min-width: 95px;
    }
  }

  .table.billing-table {
    background: ${colors.lightgrey};
    margin: 25px 0 30px;
    padding: 14px;

    th {
      padding: 10px 0;
    }

    tbody {
      tr {
        td:first-child {
          font-weight: 400;
        }
      }
    }

    td {
      font-size: 14px;
      border-top: 1px solid #ddd;
      padding: 10px 0;

      .link-unstyled {
        font-size: 14px;
      }
    }
  }

  .single-step {
    min-width: 100%;
    transition: 0.6s ease;
    padding: 0 30px 65px;
    position: relative;

    .step-button-block {
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      width: calc(100% - 50px);
      margin: 0 auto !important;
    }
  }
  .center-plan {
    box-shadow: 0px 16px 40px rgba(112, 144, 176, 0.15);
  }

  .green-check-circle {
    width: 67px;
    height: 67px;
    background-color: ${colors.green};
    display: inline-block;
    line-height: 67px;
    border-radius: 50%;
  }
  .square-icon-small {
    width: 55px;
    height: 55px;
    display: inline-block;
    border-radius: 8px;
    text-align: center;
    line-height: 51px;
  }
  .tag {
    padding: 8px;
    background-color: ${colors.green};
    border-radius: 6px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    display: inline-block;
    vertical-align: middle;
    line-height: 18px;

    &.light-green-tag {
      background-color: ${colors.lightGreen};
      color: ${colors.green};
    }
    &.light-yellow-tag {
      background-color: ${colors.lightYellow};
      color: ${colors.yellow};
    }
    &.light-blue-tag {
      background-color: ${colors.lightBlue};
      color: ${colors.blue};
    }
    &.light-red-tag {
      background-color: ${colors.lightRed};
      color: ${colors.red};
    }
    &.grey-tag {
      background-color: rgba(141, 144, 145, 0.1);
      color: ${colors.black};
    }
    .remove-tag {
      background-color: transparent;
      border: none;
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;

      svg {
        width: 12px;
      }
    }
  }
  .subdomain-placeholder {
    position: absolute;
    right: 30px;
    opacity: 0.4;
    top: 14px;
  }

  .subdomain-placeholder-left {
    .subdomain-placeholder {
      left: 38px;
      right: auto;
    }
    input {
      padding-left: 105px;
    }
  }

  .domain-config-block {
    background-color: #f9fbff;
    border-radius: 8px;

    .single-doamin-config {
      padding: 15px 25px;
      margin: 0;
      transition: 0.3s ease;

      &:first-child {
        border-radius: 8px 8px 0 0;
      }
      &:last-child {
        border-radius: 0 0 8px 8px;
      }

      &:hover {
        background-color: ${colors.lightBlue};

        .copy-text {
          opacity: 1;
          visibility: visible;
        }
      }

      .copy-text {
        position: absolute;
        right: 10px;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s ease;
      }

      p {
        margin: 0;
        padding-right: 25px;
      }
    }
  }
  .single-subdomain {
    position: relative;
    opacity: 1;
    transition: 0.4s ease;

    &:not(.block-disabled) {
      &:before {
        border: 1px solid ${colors.blue};
      }
      &:after {
        transform: scale(1);
      }
      .subdomain-toggle {
        display: none;
      }
    }

    &.block-disabled {
      opacity: 0.5;
    }

    .subdomain-toggle {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 99;
      opacity: 0;
    }

    &:before {
      position: absolute;
      width: 24px;
      height: 24px;
      border: 1px solid ${colors.darkgrey};
      right: 20px;
      top: 20px;
      content: '';
      border-radius: 50%;
      transition: 0.3s ease;
    }
    &:after {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: ${colors.blue};
      right: 27px;
      top: 27px;
      content: '';
      border-radius: 50%;
      transition: 0.3s ease;
      transform: scale(0);
    }

    .single-domain-info {
      padding: 10px 30px;
      margin: 0 -30px;
      transition: 0.3s ease;
      background-color: transparent;

      &:hover {
        background-color: ${colors.lightBlue};
      }

      h3 {
        font-size: 16px;
        line-height: 26px;
        font-weight: 600;
        margin: 0;
      }
      p {
        margin: 0;
      }

      .tag {
        font-size: 12px;
        padding: 4px 8px;
      }
    }
  }

  .choose-domain-block {
    input[type='radio'] {
      display: none;
    }

    label {
      padding: 20px;
      background-color: #fafafa;
      border-radius: 8px;
      text-align: center;
      margin: 25px 0;
      border: 2px solid #fafafa;
      width: 100%;
      transition: 0.4s ease;
      cursor: pointer;
    }

    input[type='radio']:checked + label {
      background-color: #ecf3ff;
      border: 2px solid ${colors.blue};

      .round-icon-small {
        filter: grayscale(0%);
      }
    }

    p {
      font-size: 16px;
      font-weight: 600;
      margin: 25px 0 0;
    }

    .round-icon-small {
      filter: grayscale(100%);
      transition: 0.4s ease;
      background-color: #cfe0ff;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .story-name-area {
    padding: 24px;
    background-color: #f9fbff;
    border-radius: 8px;
    margin: 25px 0;
    background-image: url(/img/bubbles.svg);
    background-size: auto;
    background-position: right center;
    background-repeat: no-repeat;

    p {
      margin-bottom: 8px;
    }   
  }

  .single-date {
    p {
      font-size: 16px;
      line-height: 26px;
      letter-spacing: -0.5px;
      color: #b5b5b5;
      margin: 0;
    }
    h4 {
      font-weight: 600;
      font-size: 16px;
      line-height: 26px;
      color: #4a4a4a;
    }
  }

  .input-unstyled {
    border: none !important;
    padding: 0 !important;
  }

  .no-pseudo {
    &:before,
    &:after {
      display: none !important;
    }
  }

  .text-with-input {
      padding: 12px;
      background-color: ${colors.lightBlue};
      display: inline-flex;
      border-radius: 5px;

      input {
        font-size: 14px;
        color: ${colors.blue};
        flex: 1;
      }
    }

    
.single-integration-block {
  padding: 15px;

  .integration-logo {
    width: 70px;
    height: 66px;
    background-color: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 8px;
}
 .button {
  padding: 13px 17px;
  font-size: 14px;
  line-height: 1;
}
 h4 {
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  margin: 15px 0 5px;
}
 p {
  font-size: 12px;
  line-height: 16px;
  color: #959595;
  margin: 0;
}
}


.success-text {
  color: ${colors.green};
  font-weight: 600;

  img {
    margin-right: 3px;
  }
}

.connect-integration-header {
  padding: 25px;
  background-color: #F9FBFF;
  border-radius: 8px 8px 0 0;

  img {
    margin-right: 20px;
  }

  h2 {
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    margin: 0 0 10px;
  }

  p {
    margin: 0;
  }
}

.icon-and-desc div {
  flex: 1;
}
.chain-list {
  list-style-type: none;
  padding: 0;

    li {
    margin-bottom: 0;
    position: relative;
    padding-left: 20px;
    padding-bottom: 15px;

    &:before {
      position: absolute;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: #000;
      content: '';
      left: 0;
      top: 7px;
      z-index: 1;
    }
    &:after {
      position: absolute;
      content: '';
      height: 100%;
      width: 1px;
      background-color: #ebebeb;
      left: 4px;
      top: 11px;
      z-index: 0;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
}
.table.domain-config-table {
  td {
    font-size: 13px;
    font-weight: 400;
  }
  tr {
    background: #f9fbff;
    transition: 0.3s ease;

    &:hover {
      background-color: ${colors.lightBlue};
    }
  }
}

.bold {
    font-weight: 700;
  }

  .form-control {
    &.small-input {
      padding: 10px;
      font-size: 14px;
    }

    &.grey-input {
      background-color: #f2f5f7;
      border: none;
      box-shadow: none;
    }
    &.white-input {
      background-color: #fff;
    }
  }

  .input-icon-prepend {
    position: relative;

    .input-icon {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);

      svg {
        display: block;
      }
    }

    input,
    select {
      padding-left: 40px !important;
    }
  }
  .input-icon-append {
    position: relative;

    .input-icon {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      svg {
        display: block;
      }
    }

    input,
    select {
      padding-right: 40px !important;
    }
  }

  .icon-both-sides {
    input,
    select {
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }

  .form-list-left-bar {
    padding: 12px;
  }

  .icon-right-margin {
    margin-right: 6px;
  }
  .icon-left-margin {
    margin-left: 6px;
  }

  .single-sidebar-button {
    padding: 8px;
    margin: 10px 0 0;
    align-items: center;
    font-size: 14px;
    color: rgba(133, 145, 163, 0.97);
    font-weight: 600;
    border-radius: 4px;

    &:hover,
    &.active {
      background-color: ${colors.midgrey};
      color: ${colors.black};
    }
  }

  .top-bar-buttons {
    .button {
      padding: 10px;
      min-width: 50px;
    }
  }

  .gap-15 {
    gap: 15px;
  }

  .black {
    color: ${colors.black} !important;
  }

  .button-unstyled {
    background-color: transparent;
    border: none;
  }

  .form-list-main {
    margin: 25px 0 0;

    .single-form-list {
      background-color: #fff;
      padding: 20px 15px;
      border-radius: 8px;
      gap: 24px;
      align-items: center;
      margin-bottom: 15px;

      &.selected {
        background: #F5F8FF;
        border: 1px solid #CFE0FF;
      }

      .pinned {
        path {
          fill: ${colors.blue};
        }
      }

      .form-list-name {
        margin-right: 60px;
      }
      button {
        svg {
          path {
            transition: 0.3s ease;
          }
        }

        &:hover {
          svg path {
            stroke: ${colors.blue};
          }
        }
      }


      label {
        margin: 0;
      }

      h3 {
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        margin: 0;
      }
      p {
        color: #89929f;
        margin: 0 0 5px;
        line-height: 120%;
      }
    }
  }

  .submission-top-bar {
    .input-icon.icon-append {
      right: 14px;
      left: auto;
    }
  }

  .relative {
    position: relative;
  }

  .submission-form-table {
    margin: 40px 0 0;

    th {
      color: #6C7789;
      background-color: ${colors.lightgrey};
    }

    th img {
      height: 20px;
      margin-right: 5px;
    }

    th label,
    td label {
      margin: 0;
    }
    td,
    th {
      vertical-align: middle;
      font-size: 13px;
    }

    td {
      color:#959595 ;
      background-color: #fff;
      font-weight: 400;
      border-bottom: 1px solid ${colors.midgrey};
      transition:0.16s ease-out ;
    }
    tr:hover td,
    .selected td{
      background-color: ${colors.lightBlue};
      color: ${colors.black};

      .view-form-icon {
        svg path {
          stroke: ${colors.blue};
        }
      }
    }
  }

  .plan-limit-popup {
    position: absolute;
    inset: auto 0 0 0;
    height: 100%;
    max-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 99;
    backdrop-filter: blur(4px);

    .plant-limit-popup-block {
      background: #ffffff;
      border: 1px solid #ff7968;
      padding: 16px;
      min-width: 700px;
      border-radius: 8px;

      .warning-icon {
        background-color: ${colors.lightRed};
        width: 64px;
        height: 64px;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        display: flex;
      }
      h3 {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        margin: 0;
      }
      p {
        margin: 0;
      }
    }
  }

.pagination-block {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin: 25px 0 0;

  p {
    margin: 0;
  }
  .pagination-select {
    min-width: 80px;
    margin: 0;
  }

  .form-control {
    width: 50px;
    height: auto;
    padding: 3px 5px;
    border-radius: 5px;
    font-size: 11px;
    background-size: 9px;
    background-position-x: 32px;
    border: 1px solid hsl(0, 0%, 80%);

  
  }

  .pagination-buttons {
    display: flex;
    gap: 5px;   

    button {
      border: 1px solid hsl(0, 0%, 80%);
      background-color: #fff;
      padding: 2px;
      width: 20px;
      border-radius: 4px;

      &:hover {
        border: 1px solid ${colors.blue};
        background-color: ${colors.blue};

        svg path {
          fill: #fff;
        }
      }
    }
  }
}

.number-pagination {
  gap: 0 10px;
  margin: 15px 0 0;

  .single-number-button {
    width: 30px;
    height: 30px;
    background: #ffffff;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #b5b5b5;

    &.active {
      border: 1px solid #3968ee;
      color: #000;
    }
  }
}

.submission-top-select {
  .dropdown-menu {
    width: 100%;
    left: 0 !important;
    right: 0;
    transform: translateX(0%) !important;
  }
}

.login-screen-main {
  min-height: 100vh;
  position: relative;
  display: flex;
  background-color: #fff;

  .login-screen-left {
    width: 50%;
    background-image: url(/img/login-bg.jpg);
    background-size: cover;
    background-position: center;
    height: 100vh;
    padding: 120px 0 0 100px;
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 1500px) {
      padding-top: 60px;
    }

    @media (max-width: 990px) {
      display: none;
     
    }

    &:after {
      position: absolute;
      inset: auto 0 0;
      width: 100%;
      height: 350px;
      background: linear-gradient(
        180deg,
        rgba(200, 220, 255, 0) 22.98%,
        #cedfff 214.92%
      );
      content: '';
      z-index: 4;
    }

    .login-top-slider {
      padding-right: 60px;

      h2 {
        font-weight: 600;
        font-size: 40px;
        line-height: 30px;
        color: #002566;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: rgba(0, 48, 133, 0.58);
      }

      .slick-dots {
        padding: 0;
        li {
          display: inline-block;
          margin-right: 10px;

          button {
            background: rgba(0, 48, 133, 0.4);
            border-radius: 20px;
            width: 8px;
            height: 8px;
            font-size: 0;
            border: none;
          }

          &.slick-active button {
            width: 25px;
            background: #003085;
          }
        }
      }
    }

    .login-screen-img {
      align-self: flex-end;
      flex-grow: 1;
      display: flex;
      align-items: flex-end;

      img {
        max-height: 80%;
        width: auto;
        margin-left: auto;
      }
    }
  }

  .login-screen-right {
    width: 50%;
    padding: 80px 125px 30px;
    display: flex;
    justify-content: center;
    position: relative;
    flex-direction: column;
    align-items: center;

    @media (max-width: 1500px) {
      padding-top: 40px;
    }
    @media (max-width: 990px) {
      width:100% ;
      padding: 40px 20px;
    }

    .login-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      flex: 1;
    }

    .login-form-header {
      margin-bottom: 42px;
    }

    .top-logo {
      max-width: 460px;
      width: 100%;
      margin-bottom: 30px;
    }

    .login-form {
      max-width: 460px;
      margin: 0 auto;
      width: 100%;

      h2 {
        font-weight: 700;
        font-size: 28px;
        line-height: 26px;
        margin-bottom: 10px;
      }

      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: rgba(171, 171, 171, 0.9);
      }

      @media (max-width: 767px) {
        h2 {
          font-size: 22px;
          line-height: 32px;
        }
      }
    }
  }

  .login-single-input {
    position: relative;
    margin-bottom: 28px;

    svg path {
      transition: 0.3s ease-out;
    }

    label {
      position: absolute;
      inset: -8px auto auto 10px;
      z-index: 9;
      padding: 0 10px;
      background-color: #fff;
      margin: 0;
    }
    .form-control {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      border: 1px solid #dfe4ec;
      border-radius: 8px;

      &:focus {
        border: 1px solid ${colors.blue};

        + .input-icon svg path {
          fill: ${colors.blue};
        }
      }

      &::placeholder {
        color: #b6b9c3;
      }

      &:-moz-placeholder {
        opacity: 1;
        color: #b6b9c3;
      }
    }
  }

  .login-form {
    label {
      font-size: 14px;
      line-height: 16px;
      color: #787e91;
      font-weight: 400;
    }

    .pwd-remember {
      label {
        margin: 0;
        padding: 7px 0 0 30px;
      }
    }
  }

  .sign-up-link {
    font-weight: 500;
    color: ${colors.black} !important ;

    a {
      color: ${colors.blue};
    }
  }
}

.or-seperator {
  text-align: center;
  position: relative;

  &:before {
    position: absolute;
    width: 100%;
    height: 1px;
    content: '';
    inset: 10px 0 auto;
    background-color: #d8d9df;
  }

  span {
    position: relative;
    z-index: 4;
    background-color: #fff;
    padding: 0 10px;
    font-weight: 500;
    color: #d8d9df;
  }
}

`;
